import React from 'react'

export interface PhoneNumbersProps {
	numbers: string
}

const PhoneNumber: React.FunctionComponent<{ number: string }> = ({
	number,
}) => {
	return <a href={`tel:${number}`}>{number.replace(/ /g, ' ')}</a>
}

export const PhoneNumbers: React.FunctionComponent<PhoneNumbersProps> = ({
	numbers,
}) => {
	const parts = numbers.split(',')

	return (
		<>
			{parts.map((part, i) => (
				<React.Fragment key={i}>
					{i !== 0 && ', '}
					<PhoneNumber number={part.trim()} />
				</React.Fragment>
			))}
		</>
	)
}
